module.exports = __webpack_public_path__ + "static/img/m7.b5324f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m7.png
// module id = 03PI
// module chunks = 12